import type { KeyValuePair } from "../../components/Forms/KeyValueMapField/KeyValueMapField";

/**
 * Converts a backend HTTP params dict to the KeyValuePair[] format used by the form.
 * Returns an empty array when params are null/undefined.
 */
export function httpParamsDictToArray(
  params: Record<string, string> | null | undefined,
): KeyValuePair[] {
  if (!params) return [];
  return Object.entries(params).map(([key, value]) => ({
    key,
    value,
    id: crypto.randomUUID(),
  }));
}

/**
 * Converts KeyValuePair[] from the form back to a backend HTTP params dict.
 * Returns undefined when the array is empty so the backend receives no params field.
 */
export function httpParamsArrayToDict(
  pairs: KeyValuePair[],
): Record<string, string> | undefined {
  if (pairs.length === 0) return undefined;
  // Object.fromEntries naturally keeps the last entry for duplicate keys.
  // Duplicate key validation is enforced upstream by the Yup schema.
  return Object.fromEntries(pairs.map((p) => [p.key, p.value]));
}
